import styled, { css } from "styled-components";
import { space, type SpaceProps } from "styled-system";
import { type ColorType, theme } from "../theme/toyotaTheme";

export const Background = styled.div<{ backgroundColor: ColorType } & SpaceProps>`
    ${space};

    ${({ backgroundColor }) =>
        backgroundColor &&
        css`
            background-color: ${theme.colors[backgroundColor]};
        `};
`;

export default Background;
